import loginAndSignup from "../../locales/es/help/loginAndSignup.json";
import howToStart from "../../locales/es/help/howToStart.json";
import createEndpoint from "../../locales/es/help/createEndpoint.json";
import createProfile from "../../locales/es/help/createProfile.json";
import aiEndpointOverview from "../../locales/es/help/aiEndpointOverview.json";
import configureAIEndpoint from "../../locales/es/help/configureAIEndpoint.json";
import testAIEndpoint from "../../locales/es/help/testAIEndpoint.json";
import helpRgp from "../../locales/es/help/helpRgp.json";
import helpPrompt from "../../locales/es/help/helpPrompt.json";
import helpPromptInput from "../../locales/es/help/helpPromptInput.json";
import AISimulatorGuide from "../../locales/es/help/AISimulatorGuide.json";
import CreateEndpointUsingJsonParams from "../../locales/es/help/CreateEndpointUsingJsonParams.json";
import CreateEndpointUsingScripts from "../../locales/es/help/CreateEndpointUsingScripts.json";
import CreateEp from "../../locales/es/help/CreateEp.json";
import DeleteEndpoint from "../../locales/es/help/DeleteEndpoint.json";
import DownloadEndpointFiles from "../../locales/es/help/DownloadEndpointFiles.json";
import epmvdos from "../../locales/es/help/Epmvdos.json";
import epmvmcp from "../../locales/es/help/Epmvmcp.json";
import epmvpd from "../../locales/es/help/epmvpd.json";
import eppromptDoc from "../../locales/es/help/EppromptDoc.json";
import Epsdos from "../../locales/es/help/Epsdos.json";
import Epsmcp from "../../locales/es/help/Epsmcp.json";
import GetAllEndpoints from "../../locales/es/help/GetAllEndpoints.json";
import getAllTests from "../../locales/es/help/getAllTests.json";
import getEndpointById from "../../locales/es/help/getEndpointById.json";
import GetEndpointDetails from "../../locales/es/help/GetEndpointDetails.json";
import GetTestStatusById from "../../locales/es/help/GetTestStatusById.json";
import HaCreateProfile from "../../locales/es/help/HaCreateProfile.json";
import HaDeleteProfile from "../../locales/es/help/HaDeleteProfile.json";
import HaGetAllProfiles from "../../locales/es/help/HaGetAllProfiles.json";
import HaGetAllTestFiles from "../../locales/es/help/HaGetAllTestFiles.json";
import HaGetProfileById from "../../locales/es/help/HaGetProfileById.json";
import HaGetRecommendations from "../../locales/es/help/HaGetRecommendations.json";
import HaGetReportById from "../../locales/es/help/HaGetReportById.json";
import HaGetSessionKey from "../../locales/es/help/HaGetSessionKey.json";
import HaProfileConfig from "../../locales/es/help/HaProfileConfig.json";
import HaProfileConfigAISspecific from "../../locales/es/help/HaProfileConfigAISspecific.json";
import HaProfileConfigMCP from "../../locales/es/help/HaProfileConfigMCP.json";
import HaProfileConfigPDocs from "../../locales/es/help/HaProfileConfigPDocs.json";
import HaProfileConfigReg from "../../locales/es/help/HaProfileConfigReg.json";
import HaProfileConfigRTO from "../../locales/es/help/HaProfileConfigRTO.json";
import Hconsolidated from "../../locales/es/help/Hconsolidated.json";
import helpAddUsers from "../../locales/es/help/HelpAddUsers.json";
import HelpAiEndpoint from "../../locales/es/help/HelpAiEndpoint.json";
import HelpCenter from "../../locales/es/help/HelpCenter.json";
import helpCreatePromptsDocs from "../../locales/es/help/HelpCreatePromptsDocs.json";
import Helpcus from "../../locales/es/help/Helpcus.json";
import helpDos from "../../locales/es/help/helpDos.json"; // 'helpDos' is used in JSX files - these keys do not match - change this to match the JSX file (in all 3 i.e. en.js, fr.js, es.js)
import Helpdosinput from "../../locales/es/help/Helpdosinput.json";
import Helpgl from "../../locales/es/help/Helpgl.json";
import helpIns from "../../locales/es/help/helpIns.json";
import helpmcp from "../../locales/es/help/helpmcp.json";
import helpmcpinput from "../../locales/es/help/helpmcpinput.json";
import helpmodelattack from "../../locales/es/help/helpmodelattack.json";
import HelpProfile from "../../locales/es/help/HelpProfile.json";
import helprginput from "../../locales/es/help/helprginput.json";
import helprgprofile from "../../locales/es/help/helprgprofile.json";
import helprto from "../../locales/es/help/helprto.json";
import helprtoinput from "../../locales/es/help/helprtoinput.json";
import HelpSubscreenTemplate from "../../locales/es/help/HelpSubscreenTemplate.json";
import ListAllEndpointConfigurations from "../../locales/es/help/ListAllEndpointConfigurations.json";
import Llmapi from "../../locales/es/help/Llmapi.json";
import Llmprofile from "../../locales/es/help/Llmprofile.json";
import RunTest from "../../locales/es/help/RunTest.json";
import StopTest from "../../locales/es/help/StopTest.json";
import UpdateEndpoint from "../../locales/es/help/UpdateEndpoint.json";
import Whlic from "../../locales/es/help/Whlic.json";
import thelp from "../../locales/es/help/thelp.json";
import helpScan from "../../locales/es/help/helpScan.json";
import epvmcp from "../../locales/es/help/epvmcp.json";
import helpgh from "../../locales/es/help/helpgh.json";
import eprc from "../../locales/es/help/eprc.json";
import eprto from "../../locales/es/help/eprto.json";
import epvdos from "../../locales/es/help/epvdos.json";
import Helppdf from "../../locales/es/help/Helppdf.json";
import HelpHarness from "../../locales/es/help/HelpHarness.json";







// ... import more spanish help json files here

const esHelp = {
  loginAndSignup,
  HelpHarness,
  Helppdf,
  epvdos,
  eprto,
  howToStart,
  createEndpoint,
  createProfile,
  aiEndpointOverview,
  configureAIEndpoint,
  testAIEndpoint,
  helpRgp,
  helpPrompt,
  helpPromptInput,
  helpPromptInput,
  AISimulatorGuide,
  CreateEndpointUsingJsonParams,
  CreateEndpointUsingScripts,
  CreateEp,
  DeleteEndpoint,
  DownloadEndpointFiles,
  epmvdos,
  epmvmcp,
  epmvpd,
  eppromptDoc,
  Epsdos,
  Epsmcp,
  GetAllEndpoints,
  getAllTests,
  getEndpointById,
  GetEndpointDetails,
  GetTestStatusById,
  HaCreateProfile,
  HaDeleteProfile,
  HaGetAllProfiles,
  HaGetAllTestFiles,
  HaGetProfileById,
  HaGetRecommendations,
  HaGetReportById,
  HaGetSessionKey,
  HaProfileConfig,
  HaProfileConfigAISspecific,
  HaProfileConfigMCP,
  HaProfileConfigPDocs,
  HaProfileConfigReg,
  HaProfileConfigRTO,
  Hconsolidated,
  helpAddUsers,
  HelpAiEndpoint,
  HelpCenter,
  helpCreatePromptsDocs,
  Helpcus,
  helpDos, // 'helpDos' is used in JSX files - these keys do not match - change this to match the JSX file (in all 3 i.e. en.js, fr.js, es.js)
  Helpdosinput,
  Helpgl,
  helpIns,
  helpmcp,
  helpmcpinput,
  helpmodelattack,
  HelpProfile,
  helpPrompt,
  helpPromptInput,
  helprginput,
  helpScan,
  helpRgp,
  helprgprofile,
  helprto,
  helprtoinput,
  HelpSubscreenTemplate,
  ListAllEndpointConfigurations,
  Llmapi,
  Llmprofile,
  RunTest,
  StopTest,
  UpdateEndpoint,
  Whlic,
  thelp,
  epvmcp,
  helpgh,
  eprc

  // add more spanish help jsons here
};

export default esHelp;
